import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { trackEvent } from '../../../api/Pendo';
import { AuthenticationType } from '../../../api/AuthenticationType';

const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    trackEvent('UserLoggedOut', { authProvider: AuthenticationType.AUTH0 });
    logout({
      logoutParams: { federated: true, returnTo: window.location.origin },
    });
  }, [logout]);

  return <div>Logging out...</div>;
};

export default Logout;
